<div class="w-full h-full p-4 flex flex-col justify-start items-center font-inter">
    <div class="w-full flex flex-col justify-start items-start gap-2">
        <div class="w-full flex flex-row justify-between items-start gap-2">
            <div class="flex flex-row justify-start items-start gap-2 min-w-0">
                <fm-avatar
                    size="profileView"
                    [avatarLocation]="userProfile.photoUrl"
                    [isSaved]="userProfile.saved" />

                <div class="flex flex-col justify-start items-starts w-full gap-2 min-w-0">
                    <div
                        class="w-full text-left block truncate text-bluegrey text-18 leading-[normal] font-semibold"
                        >{{ userProfile.displayName }}</div
                    >
                    <div
                        class="flex flex-col justify-start items-starts w-full gap-1 text-muted-color text-12 leading-[normal] font-light">
                        <div>
                            <fm-display-timezone-local-time [timezone]="userProfile.timeZone" />
                        </div>
                        <div>
                            {{ userProfile.compSessions | number }}
                            {{ userProfile.compSessions == 1 ? 'session' : 'sessions' }}
                        </div>
                        @if (userProfile.sharedSessions) {
                            <div>{{ userProfile.sharedSessions }} together</div>
                        }
                        @if (userProfile.lastSessionTime) {
                            <div>{{ lastMet }}</div>
                        }
                    </div>
                </div>
            </div>

            <div class="flex flex-row justify-start items-start gap-2">
                @if (!userProfile.saved) {
                    <p-button
                        (click)="onClickAddToFavofites()"
                        size="small"
                        severity="primary"
                        [outlined]="true"
                        label="Add to Favorites"
                        icon="pi pi-star"></p-button>
                }
                <fm-actions-menu
                    [showReportProfile]="true"
                    [timeZone]="userProfile.timeZone"
                    [targetUserDisplayName]="userProfile.displayName"
                    [targetUserId]="userProfile.uid"
                    [targetUserProfileUrl]="userProfile.profileUrl"
                    [targetUserPhotoUrl]="userProfile.photoUrl"
                    [status]="userProfile.status"
                    [snoozeStatus]="userProfile.snoozeStatus"
                    [saved]="userProfile.saved"
                    [sharedAvailability]="userProfile.sharedAvailability"
                    [showSeeAvailability]="true"
                    [showViewProfile]="false"
                    [source]="'profile'"
                    [snoozeExpiresAt]="userProfile.snoozeExpiresAt" />
            </div>
        </div>
    </div>

    <div
        class="w-full flex-1 overflow-auto flex flex-col justify-start lg:flex-row lg:justify-center items-start gap-4 mt-4">
        <div
            class="flex-1 w-full flex flex-col justify-start items-start min-w-0 rounded-lg border border-[#E8DCCD] p-4">
            @if (descriptionTagDisplayNames.length > 0) {
                <div class="w-full flex flex-col items-start justify-start gap-2">
                    <div class="text-color text-14 leading-normal font-medium">My Tags</div>

                    <div class="w-full flex flex-row gap-1 flex-wrap items-center justify-start">
                        @for (name of descriptionTagDisplayNames; track name) {
                            <p-tag
                                styleClass="!text-12 !leading-[normal] !h-[25px] !rounded-lg !border !border-[#E8DCCD] !bg-[#F9F5F0] !font-medium"
                                severity="secondary"
                                [value]="name" />
                        }
                    </div>
                </div>
            }

            @if (activityTagDisplayNames.length > 0) {
                <div class="h-[1px] border border-[#E8DCCD] my-3 w-full"></div>

                <div class="w-full flex flex-col items-start justify-start gap-2">
                    <div class="text-color text-14 leading-normal font-medium">My Focus</div>

                    <div class="w-full flex flex-row gap-1 flex-wrap items-center justify-start">
                        @for (name of activityTagDisplayNames; track name) {
                            <p-tag
                                styleClass="!text-12 !leading-[normal] !h-[25px] !rounded-lg !border !border-[#E8DCCD] !bg-[#F9F5F0] !font-medium"
                                severity="secondary"
                                [value]="name" />
                        }
                    </div>
                </div>
            }

            @if (userProfile.group.length > 0) {
                <div class="h-[1px] border border-[#E8DCCD] my-3 w-full"></div>
                <div class="w-full flex flex-col items-start justify-start gap-2">
                    <div class="text-color text-14 leading-normal font-medium">My groups</div>

                    <div class="w-full flex flex-col gap-1 items-start justify-start">
                        @for (group of userProfile.group; track group.groupName) {
                            <div class="h-8 px-1 flex items-center bg-[#F9F5F0] rounded-3xl">
                                <img
                                    class="h-6 w-6 rounded-full"
                                    [src]="
                                        group.groupLogo
                                            ? group.groupLogo
                                            : '/assets/images/default_group.svg'
                                    " />
                                <span class="ml-1 text-12 leading-[normal] text-color">{{
                                    group.groupName
                                }}</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        <div
            class="flex-1 w-full flex flex-col justify-start items-start min-w-0 rounded-lg border border-[#E8DCCD] p-4">
            <div class="text-color text-14 leading-normal font-medium">About me</div>
            @for (qanda of userProfile.qanda; track qanda['question']) {
                @if (qanda.public) {
                    <div
                        class="w-full flex flex-col justify-center items-center p-2 bg-[rgba(249,245,240,0.5)] rounded-lg gap-2 text-12 leading-[120%] mb-2 first:mt-2">
                        <div class="w-full text-left text-color font-medium">
                            {{ qanda['question'] }}
                        </div>
                        <div
                            class="w-full text-left text-muted-color font-light break-words break-all">
                            {{ qanda['answer'] }}
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</div>
